
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {  EVENT_INDICATOR_COLOR, HIGHLIGHT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, 
    FONT_FAMILY_REGULAR, WHITE_FONT_COLOR } from '../../../../styles/fonts/MCFontConstants';

export const CalendarWrapper = styled.div`
    //wrapper styles
    & .p-datepicker,
    .p-datepicker-header {
        background: ${DARK_NAVY_FONT_COLOR} !important;
        color: ${WHITE_FONT_COLOR};
        border: none !important;
        border-radius: 6px !important;
    }

    & .p-calendar {
        width: 352px;
        height: 378px;
        font-family: ${FONT_FAMILY_REGULAR} !important;
        border-radius: 6px !important;
        box-shadow: 0px 0px 6px #00000029;
        border: none !important;
        ${media.smalDevice`
            padding:0 !important;
        `}
        ${media.mobileDevice`
            width: 100vw !important;
            max-width:100vw !important;
            border-radius: none !important;
            box-shadow: none !important;
            min-height:unset !important;
            padding:0 !important;
            height: unset;
        `}
    }
    & .p-datepicker-group {
        width: 100% !important;
        height: 100% !important;
        & .p-datepicker-header {
            padding: 0 !important;
        }
        & .p-datepicker-calendar-container {
            width: 100% !important;
            height: 86% !important;
            ${media.mobileDevice`
                height: unset;
            `}
            & .p-datepicker-calendar {
                margin: 0 !important;
            }
            & table {
                width: 100% !important;
                height: 100% !important;
            }
        }
    }
    & .p-datepicker-group-container {
        margin: 0 !important;
        width: 100% !important;
        height: 100% !important;
    }

    //header styles
    & .p-datepicker-title,
    .p-datepicker-prev,
    .p-datepicker-next,
    .p-link {
        display: none !important;
    }
    & .calendar-header {
        background: ${DARK_NAVY_FONT_COLOR} !important;
        color: ${WHITE_FONT_COLOR};
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        position: relative;
        font-size: 16px !important;
        padding: 8px 0 8px 0;
        & .month-week-nav {
            align-items: center;
            display: flex;
        }
        & .header-title-container {
            width: max-content;
            margin-left: 12px !important;
            margin-right: 12px !important;
            display: flex;
            height: 28px;
            align-content: center;
            justify-content: center;
            & .header-title {
                font-family: ${FONT_FAMILY_DEMI} !important;
                font-size: 18px !important;
                ${media.mobileDevice`
                    font-size: 16px !important;
                `}
                ${media.exSmallDevice`
                    font-size: 14px !important;
                 `}
            }
        }
    }

    //footer styles
    & .p-datepicker-footer {
        ${media.mobileDevice`
            margin: ${(props) =>
                props.calendarView === 'Week' ? '5px 0 0 0' : '0px'};
        `}
    }
    & .calendar-footer {
        display: none;
        position: relative;
        ${media.largeDevice`
            display: none;
        `}
        ${media.mobileDevice`
            display: flex;
            justify-content: center;
        `}
        & .month-week-arrow {
            position: relative;
            top: 27px;
            z-index: 11;
        }
        & .week-month-arrow {
            position: relative;
            top: 27px;
            z-index: 11;
        }
        & .calendar-curve {
            display: none;
            ${media.largeDevice`
                display: none;
            `}
            ${media.mobileDevice`             
                display: flex; 
                position: absolute;
                width: 125px;
                height: 102px;                
                z-index: 2;
            `}
        }
    }

    //calendar table styles
    & .p-datepicker table tbody tr {
        ${media.mobileDevice`
            /* height: 38px; */
            height: ${(props) =>
                props.calendarView === 'Week' ? '35px' : '7vh'};
            max-height: 40px;    
        `}
        ${media.exSmallDevice`
            height: 5.5vh;
        `}
    }
    & .p-datepicker table th {
        font-weight: unset;
        font-family: AvenirNextWorld Regular !important;
    }
    & .p-datepicker table th > span {
        font-size: 16px !important;
        font-family: AvenirNextWorld Regular !important;
        ${media.exSmallDevice`
            width: 1.2rem !important;
            height: 1.2rem !important;
            font-size: 12px !important;
        `}
    }
    & .p-datepicker table td > span {
        overflow: visible;
        font-size: 16px !important;
        width: 28px;
        height: 28px;
        ${media.mobileDevice`
            width: 1.8rem !important;
            height: 1.8rem !important;
        `}
        ${media.exSmallDevice`
            width: 1.2rem !important;
            height: 1.2rem !important;
            font-size: 12px !important;
        `}
    }
    & .p-datepicker table td > span:focus {
        box-shadow: none;
    }
    & .p-datepicker table td:not(.p-datepicker-today) span:hover {
        background: none !important;
    }
    & .p-datepicker-today > span {
        background-color: ${HIGHLIGHT_COLOR} !important;
    }
    & .p-datepicker table td:not(.p-datepicker-today) > span {
        font-family: ${FONT_FAMILY_REGULAR} !important;
    }
    & .p-datepicker-today {
        & span {
            background-color: ${WHITE_FONT_COLOR};
            font-family: ${FONT_FAMILY_DEMI} !important;
        }
    }
    & .p-datepicker table td:not(.p-datepicker-today) span.p-highlight {
        color: ${WHITE_FONT_COLOR};
        background-color: unset !important;
        border: 1px solid ${EVENT_INDICATOR_COLOR};
        ${media.mobileDevice`
            border: 1px solid ${HIGHLIGHT_COLOR};
        `}
    }
    & .p-disabled {
        opacity: 0.3;
    }

    & .p-datepicker table td {
        position: relative;

        & .pixieDust {
            position: absolute;
            bottom: -35% !important;
            left: 43%;
            width: 4.5px;
            height: 4.5px;
            border-radius: 50%;
            background: ${EVENT_INDICATOR_COLOR};
            ${media.mobileDevice`
                position: absolute;
                bottom: -36% !important;
            `}
        }
    }
`;
